import React from "react";
import {Field} from "formik";
import {InputSwitch} from 'primereact/inputswitch';

export default function NsFieldCheckbox({
                                            name,
                                            formikRef,
                                            onChange = () => {
                                            },
                                            values = [],
                                            isDisabled = false,
                                            isRequired = false,
                                            validate = () => {
                                            },
                                            valoreNoFormik,
                                            isFormFieldInvalid,
                                        }) {


    return (
        formikRef && typeof formikRef !== "undefined" ?
            <Field
                name={name}
                component={InputSwitch}
                className="ms-2" //aggiunto ms-2 per sostituire lo spazio
                required={isRequired}
                disabled={isDisabled}
                onChange={(e) => {
                    if (formikRef) {
                        formikRef.current.setFieldValue(name, e.value ? '1' : '0');
                    }
                    onChange(e.value ? true : false);
                }}
                checked={parseInt((formikRef && values[name]) ? values[name] : valoreNoFormik) === 1 ? true : false}
                validate={validate}
                invalid={isFormFieldInvalid()}
            />
            :
            <InputSwitch
                name={name}
                className="ms-2" //aggiunto ms-2 per sostituire lo spazio
                required={isRequired}
                disabled={isDisabled}
                onChange={(e) => {
                    onChange(e.value ? true : false);
                }}
                checked={parseInt((formikRef && values[name]) ? values[name] : valoreNoFormik) === 1 ? true : false}
                invalid={isFormFieldInvalid()}
            />
    );
}